import { Box } from "@mui/material";

import "@/wcComponents/TermOfUse.ts";

const TermsOfUse = () => {
  return (
    <Box
      sx={{
        px: 6,
        py: 5,
        bgcolor: "#fff",
        display: "grid",
        gap: 2,
      }}
    >
      <wc-terms-of-use />;
    </Box>
  );
};

export default TermsOfUse;
